import { Pipe, PipeTransform } from '@angular/core';
import { AddressDto } from '@fleet-beat/core';
import { addressToString } from '@fleet-beat/core';

@Pipe({
  name: 'address',
})
export class AddressPipe implements PipeTransform {
  transform(address: AddressDto): string {
    if (!address) {
      return '';
    }

    return addressToString(address);
  }
}
